import {InputItem} from './inputitem/inputitem.js';
import {useRoutingStore} from '../store.js';
import {mapActions} from "pinia";

export const InputsPanel = {

    components:{
        InputItem,
    },

    props: {
        styleClass: {
            type:String,
        }
        // Пропсы компонента
    },

    methods: {
        // Методы компонента
        ...mapActions(useRoutingStore, [
            'setName',
        ])
    },


    // language=Vue
    template: `
      <div :class="styleClass">
        <InputItem
            :inputType="'text'"
            :isCleanable="true"
            :placeholder="'Комментарий к МЛ'"
            :changeAction="setName"
            :minLength="4"
            :maxLength="15"
        />
      </div>
    `
};